// Shared technical specifications and company information
export const COMPANY_INFO = {
  foundedYear: 1956,
  yearsOfExperience: new Date().getFullYear() - 1956,
  companyName: 'Roll Forming Machine & Die Manufacturing Co. Ltd.',
  location: {
    address: '209 Wilkinson Road',
    city: 'Brampton',
    province: 'Ontario',
    postalCode: 'L6T 4M2',
    country: 'Canada'
  },
  contact: {
    phone: '905.796.5885',
    fax: '905.796.5471',
    email: 'sales@rollformmachine.ca'
  }
};

export const TECHNICAL_SPECS = {
  materialThickness: {
    min: '.003"',
    max: '.625"',
    range: '.003" to .625"'
  },
  materialStrength: {
    max: '190K',
    description: 'Up to 190K yield strength'
  },
  technology: {
    design: '3D CAD/CAM technology',
    precision: '±0.001" tolerance on critical dimensions'
  }
};

export const SAFETY_FEATURES = [
  'Light curtain protection',
  'Emergency stop controls',
  'Two-hand operation',
  'Pressure relief valves',
  'Safety monitoring systems'
];

export const CONTROL_FEATURES = [
  'PLC control systems',
  'HMI touch screens',
  'Variable speed drives',
  'Position feedback',
  'Remote monitoring capabilities'
];

export const INDUSTRIES_SERVED = [
  'Automotive',
  'Construction', 
  'Transportation',
  'Electronics',
  'Architecture',
  'HVAC',
  'Appliance Manufacturing'
];

export const VALUE_PROPOSITIONS = {
  experience: `Over ${COMPANY_INFO.yearsOfExperience} years of precision engineering excellence`,
  quality: 'Consistent quality and exceptional performance',
  innovation: 'Latest technology and innovative design solutions',
  service: 'Complete support from concept to production',
  reliability: 'Built for long service life in demanding environments'
};